<script>
import forminput from "../../FormComponet/forminput.vue";
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import formcombobox from "../../FormComponet/formcombobox.vue";
import formcheckbox from "../../FormComponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetay from "@/models/StrPerfTablolarDetay"; 
import formtreeselect from "@/router/views/FormComponet/formtreeselect.vue";

export default {
  mixins: [Api, Sabit, StrPerfTablolarDetay],
  props: ["Id", "AddEdit","DonemId"],
  data() {
    return {
      FormData: {},
    };
  },
  components: {
    Loader,
    forminput,
    formcheckbox,
    formcombobox,
    formtextarea,
    formtreeselect
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get();
    },
  },

  methods: {
    onSubmit() {
      this.$v.$touch();
     
      if (!this.$v.$invalid) {

        if (
          this.FormData.Aktif == "true" ||
          this.FormData.Aktif == true
        ) {
          this.FormData.Aktif = true;
        } else {
          this.FormData.Aktif = false;
        }

        if (
          this.FormData.DetayVar == "true" ||
          this.FormData.DetayVar == true
        ) {
          this.FormData.DetayVar = true;
        } else {
          this.FormData.DetayVar = false;
        }

        if (
          this.FormData.BaskaBirimlerGorsun == "true" ||
          this.FormData.BaskaBirimlerGorsun == true
        ) {
          this.FormData.BaskaBirimlerGorsun = true;
        } else {
          this.FormData.BaskaBirimlerGorsun = false;
        }

        if (
          this.FormData.DetaydanHesaplamasin == "true" ||
          this.FormData.DetaydanHesaplamasin == true
        ) {
          this.FormData.DetaydanHesaplamasin = true;
        } else {
          this.FormData.DetaydanHesaplamasin = false;
        }

        if (
          this.FormData.HedefDonemlerindeKapali == "true" ||
          this.FormData.HedefDonemlerindeKapali == true
        ) {
          this.FormData.HedefDonemlerindeKapali = true;
        } else {
          this.FormData.HedefDonemlerindeKapali = false;
        }

        if (
          this.FormData.KanitGerekli == "true" ||
          this.FormData.KanitGerekli == true
        ) {
          this.FormData.KanitGerekli = true;
        } else {
          this.FormData.KanitGerekli = false;
        }

        if (
          this.FormData.KanitGerekli == "true" ||
          this.FormData.KanitGerekli == true
        ) {
          this.FormData.KanitGerekli = true;
        } else {
          this.FormData.KanitGerekli = false;
        }

        if (this.AddEdit == "Add") { 
           this.$delete(this.FormData, "Id");
              this.Post("StrPerfTablolarDetay", this.FormData).then((res) => {
        
                  if (res) {
                      this.$emit("TableUpdate");
                      this.$bvModal.hide("StrPerfTablolarDetay");
                  }   
              });
        } else {
         
         this.Update("StrPerfTablolarDetay", this.FormData).then((res) => {
              if (res) {
                this.$emit("TableUpdate");
                this.$bvModal.hide("StrPerfTablolarDetay");
              }
         });

        }
      }
    },
    Get(){
      let Page= {
        PageNumber: "1",
        PageSize: "9999",
      }
           
            let Filter="&DonemId="+this.DonemId;
            this.FormDataType.TabloId.ComboDataArray=[];

            this.ActionsFilterGet({ Service: "StrPerfTablo", Page: Page, Filter: Filter }).then((res) => {

              for(var i=0; i<res.Data.length; i++)
                {
                    this.FormDataType.TabloId.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Adi})
                }
            });
    },
    secimsil(kontrol){
      if (kontrol==1){
        this.FormData.SorguId=null;
      }
    }

  },
  created(){

    
      
            

  }

};
</script>

<template>


  <Loader>

  
  
    <b-modal
      id="StrPerfTablolarDetay"
      size="lg"
       :title="this.AddEdit == 'Edit' ? $t('StrPerfTablolarDetay.AddEdit.FormTitleEdit')
          : $t('StrPerfTablolarDetay.AddEdit.FormTitleAdd')"
      title-class="font-18"
      hide-footer
    >

  
          <Form @submit.prevent="onSubmit">
            
            
              <div class="row">
                <div class="col-md-12">

                  <formtreeselect
                   :FormDataType="FormDataType.TabloId"
                   :Value="FormData.TabloId"
                   :v="$v.FormData.TabloId"
                   @input="FormData.TabloId = $event"
                
                 /> 


                </div>
              </div>

               <div class="row">
                <div class="col-md-12">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.GostergeTipiId"
                    :Value="FormData.GostergeTipiId"
                    :v="$v.FormData.GostergeTipiId"
                    @input="FormData.GostergeTipiId = $event"
                  />

                </div>
              </div> 

              <div class="row">
                <div class="col-md-12">
                  <forminput
                    :title_position="'d-block'"
                    :labels_lg="4"
                    :FormDataType="FormDataType.Gostergesi"
                    :Value="FormData.Gostergesi"
                    :v="$v.FormData.Gostergesi"
                    @input="FormData.Gostergesi = $event"
                  />     

                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <forminput
                    :title_position="'d-block'"
                    :labels_lg="4"
                    :FormDataType="FormDataType.Aciklama"
                    :Value="FormData.Aciklama"
                    :v="$v.FormData.Aciklama"
                    @input="FormData.Aciklama = $event"
                  />     


                </div>
              </div>
             

              <div class="row">
                <div class="col-md-4">

                  <forminput
                    :title_position="'d-block'"
                    :labels_lg="4"
                    :FormDataType="FormDataType.SiraNo"
                    :Value="FormData.SiraNo"
                    :v="$v.FormData.SiraNo"
                    @input="FormData.SiraNo = $event"
                  />  

                </div> 
               

                <div class="col-md-4">
                  <formcheckbox
                    :title_position="'d-block'"
                    :labels_lg="12"
                    :FormDataType="FormDataType.Aktif"
                    :Value="FormData.Aktif"
                    :v="$v.FormData.Aktif"
                    @input="FormData.Aktif = $event"
                  />

                </div>

                <div class="col-md-4">
                  
                  <formcheckbox
                    :title_position="'d-block'"
                    :labels_lg="12"
                    :FormDataType="FormDataType.KanitGerekli"
                    :Value="FormData.KanitGerekli"
                    :v="$v.FormData.KanitGerekli"
                    @input="FormData.KanitGerekli = $event"
                  />

                </div>
               
              </div>
            

              

              <div class="row">
                <div class="col-md-12">
                  <forminput
                    :title_position="'d-block'"
                    :labels_lg="4"
                    :FormDataType="FormDataType.HedefEtkisi"
                    :Value="FormData.HedefEtkisi"
                    :v="$v.FormData.HedefEtkisi"
                    @input="FormData.HedefEtkisi = $event"
                  />   


                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.OlcumPeriyodu"
                    :Value="FormData.OlcumPeriyodu"
                    :v="$v.FormData.OlcumPeriyodu"
                    @input="FormData.OlcumPeriyodu = $event"
                  />

                </div>

                <div class="col-md-4">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.RaporlamaSikligi"
                    :Value="FormData.RaporlamaSikligi"
                    :v="$v.FormData.RaporlamaSikligi"
                    @input="FormData.RaporlamaSikligi = $event"
                  />

                </div>

                <div class="col-md-4">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.OlcuBirimiId"
                    :Value="FormData.OlcuBirimiId"
                    :v="$v.FormData.OlcuBirimiId"
                    @input="FormData.OlcuBirimiId = $event"
                  />


                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.GostergeTuruId"
                    :Value="FormData.GostergeTuruId"
                    :v="$v.FormData.GostergeTuruId"
                    @input="FormData.GostergeTuruId = $event"
                  />

                </div>

                <div class="col-md-4">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.GostergeYonuId"
                    :Value="FormData.GostergeYonuId"
                    :v="$v.FormData.GostergeYonuId"
                    @input="FormData.GostergeYonuId = $event"
                  />

                </div>

                <div class="col-md-4">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.OlcumHesaplamaTuruId"
                    :Value="FormData.OlcumHesaplamaTuruId"
                    :v="$v.FormData.OlcumHesaplamaTuruId"
                    @input="FormData.OlcumHesaplamaTuruId = $event"
                  />

                </div>
              </div>

              <div class="row">
                <div class="col-md-11">
                  <formtextarea
                      :FormDataType="FormDataType.FormulIcerik"
                      :Value="FormData.FormulIcerik"
                      :v="$v.FormData.FormulIcerik"
                      @input="FormData.FormulIcerik = $event"
                                     
                   /> 

                </div>

                <div class="col-md-1">
               <div class="action-is w-100 d-flex justify-content-center align-items-center">
                   <i style="margin-left:10px;margin-top:45px;" class="fas fa-pencil-alt" v-b-modal.FormulOLustur > </i>
                </div>

                </div>

                
              </div>

              <div class="row">
                <div class="col-md-12">
                 

                  <formtreeselect
                    :FormDataType="FormDataType.SorguId"
                    :Value="FormData.SorguId"
                    :v="$v.FormData.SorguId"
                    @input="FormData.SorguId = $event"
                    @unselect="secimsil($event)"
                  />

                </div>
              </div>
      

              <div class="row">
                <div class="col-md-4">
                  <formcheckbox
                    :title_position="'d-block'"
                    :labels_lg="12"
                    :FormDataType="FormDataType.DetayVar"
                    :Value="FormData.DetayVar"
                    :v="$v.FormData.DetayVar"
                    @input="FormData.DetayVar = $event"
                  />

                </div>

                <div class="col-md-4">
                  <formcheckbox
                    :title_position="'d-block'"
                    :labels_lg="12"
                    :FormDataType="FormDataType.DetaydanHesaplamasin"
                    :Value="FormData.DetaydanHesaplamasin"
                    :v="$v.FormData.DetaydanHesaplamasin"
                    @input="FormData.DetaydanHesaplamasin = $event"
                  />

                </div>

                <div class="col-md-4">
                  <formcheckbox
                    :title_position="'d-block'"
                    :labels_lg="12"
                    :FormDataType="FormDataType.BaskaBirimlerGorsun"
                    :Value="FormData.BaskaBirimlerGorsun"
                    :v="$v.FormData.BaskaBirimlerGorsun"
                    @input="FormData.BaskaBirimlerGorsun = $event"
                  />


                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.Renk"
                    :Value="FormData.Renk"
                    :v="$v.FormData.Renk"
                    @input="FormData.Renk = $event"
                  />

                </div>

                <div class="col-md-6">
                  <formcheckbox
                    :title_position="'d-block'"
                    :labels_lg="12"
                    :FormDataType="FormDataType.HedefDonemlerindeKapali"
                    :Value="FormData.HedefDonemlerindeKapali"
                    :v="$v.FormData.HedefDonemlerindeKapali"
                    @input="FormData.HedefDonemlerindeKapali = $event"
                  />

                </div>

              </div> 
             

              <hr />

              <button class="btn btn-primary" type="submit">{{ $t("StrPerfTablolarDetay.AddEdit.Button") }}</button>
          </Form>


    </b-modal>
  </Loader>
</template>
